/* eslint-disable max-len */
const React = require('react');

const Default = () => (
  <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.0005 25.5C19.9023 25.5 25.4971 19.9034 25.4971 13C25.4971 6.09657 19.9023 0.5 13.0005 0.5C6.09869 0.5 0.503906 6.09657 0.503906 13C0.503906 19.9034 6.09869 25.5 13.0005 25.5Z" fill="white" stroke="#BFBFBF" />
    <path d="M24.2539 13C24.2539 18.252 20.6554 22.665 15.7894 23.9033C14.7896 24.1578 13.7558 23.3134 13.7546 22.002L13.7466 13.0007V12.9993L13.7546 3.99799C13.7558 2.68656 14.7896 1.84223 15.7894 2.09666C20.6554 3.33501 24.2539 7.74798 24.2539 13Z" fill="var(--andes-color-blue-500)" stroke="white" strokeWidth="1.5" />
  </svg>
);

module.exports = Default;
